import styled from 'styled-components';
import { Colors } from '../../styles/colors';
import { Icon } from '../general/Icon';
import { FlexboxCenter, Flexbox } from '../general/Layout';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: ${({ columnTemplate }: any) => columnTemplate || 'span 4'};

  padding: .5rem 0 1.5rem;
`;

export const HeadlineWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem 0;

  > div:first-child {
    margin-right: auto;
  }

  > div:last-child {
    margin-left: 1.5rem;
  }
`;

export const Headline = styled.div`
  font-weight: 700;
`;

export const AdditionalItemDivider = styled.div`
  min-height: 1px;
  background-color: ${Colors.grayLight};
  margin: 0 1.5rem;
  font-weight: 700;

  :last-of-type {
    min-height: 0;
  }
`;

export const EditIconWrapper = styled.div`
  &:hover {
    cursor: pointer;
    
    @media (pointer: fine) {
      color: ${Colors.tertiary};
    }
  }
`;

export const EditIcon = styled(Icon)`
  &:hover {
    cursor: pointer;
    
    @media (pointer: fine) {
      color: ${Colors.tertiary};
    }
  }
`;

export const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DataRow = styled(Flexbox)`
  padding: 1rem 0;

  &:last-child {
    padding: 1rem 0 0 0;

  }
`;

export const DataRowHeader = styled.div`
  flex: 1;
  margin-right: 5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const DataRowContent = styled(FlexboxCenter)``;
